<template>
    <el-main>
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </el-main>
</template>
<script>
export default {
  name: 'main-container',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    };
  },
};
</script>
<style>
.color-style#navbar{
  /* height: auto !important; */
  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,1) 72%,rgba(255,255,255,0) 100%) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  border-bottom: none;
  .el-menu--horizontal > .el-menu-item{
    color: grey !important;
  }
  /* position: relative; */
  div.logo{
      background-image: url(../../assets/img/logo-1.png) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/MainContainer.vue